import { render, staticRenderFns } from "./Subtitle.vue?vue&type=template&id=3221dd0a&scoped=true&"
import script from "./Subtitle.vue?vue&type=script&lang=ts&"
export * from "./Subtitle.vue?vue&type=script&lang=ts&"
import style0 from "./Subtitle.vue?vue&type=style&index=0&id=3221dd0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3221dd0a",
  null
  
)

export default component.exports